<template>
  <div class="content">
    <el-input v-model="queryParams.serviceKey" placeholder="业务名称" clearable style="width: 210px"></el-input>
    <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
    <el-button type="primary" icon="el-icon-refresh" @click="reset">重置</el-button>
    <el-button type="primary" icon="el-icon-plus" @click="handleAdd" v-hasPermi="['system:module:add']">新增</el-button>
    <div class="table" style="margin-top: 10px">

      <el-table
          v-loading="loading"
          :data="dictionaryList"
          row-key="id"
          border
          :default-expand-all="isExpandAll"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
        <el-table-column prop="serviceKey" label="业务名称" :show-overflow-tooltip="true" width="260"></el-table-column>
        <el-table-column prop="serviceValue" label="业务值" align="center" :show-overflow-tooltip="true" :formatter="dateFormatServiceValue"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center">
          <template slot-scope="scope">
            <span>{{ parseTime(scope.row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="360" fixed="right">
          <template slot-scope="scope">
            <el-button
                size="mini"
                type="primary" plain
                icon="el-icon-edit"
                @click="handleUpdate(scope.row)"
                v-hasPermi="['system:menu:edit']"
            >修改</el-button>
            <el-button v-if="scope.row.parentId === -1"
                size="mini"
                type="primary" plain
                icon="el-icon-plus"
                @click="handleAdd(scope.row)"
                v-hasPermi="['system:menu:add']"
            >新增</el-button>
            <el-button
                size="mini"
                type="primary" plain
                icon="el-icon-delete"
                @click="handleDelete(scope.row)"
                v-hasPermi="['system:menu:remove']"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="block" style="margin-top: 30px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <!-- 添加或修改菜单对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="680px" append-to-body :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="根业务名称" prop="parentId" >
              <el-select v-model="form.parentId" filterable clearable placeholder="请选择根业务名称" @clear="handleClear" @change="handleChange">
                <el-option v-for="item in optParentDictionary" :key="item.id" :label="item.serviceKey" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="业务名称" prop="serviceKey">
              <el-input v-model="form.serviceKey" placeholder="请输入业务名称" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="业务值" prop="serviceValue" v-if="showServiceValueInput">
              <el-input-number v-model="form.serviceValue" placeholder="请输入业务值" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import {
  dataDictionaryParentAll,
  dataDictionaryList,
  delDataDictionary,
  addDataDictionary,
  updateDataDictionary,
  getDataDictionary,
} from "@/api/api.js";
import dictionary from "@/views/device/dictionary.vue"; //获取数据字典列表
export default {
  name: "source",
  data() {
    return {
      // 是否展开，默认全部折叠
      isExpandAll: false,
      // 遮罩层
      loading: true,
      // 搜索
      queryParams:{},
      page: 1,
      pageSize: 10,
      total: 0,
      dictionaryList: [],
      // 根业务选项
      optParentDictionary: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      //是否可以编辑
      disabled:false,
      // 表单参数
      form: {},
      showServiceValueInput:false,
      rules: {
        serviceKey: [
          { required: true, message: "业务名称不能为空", trigger: "blur" },
        ],
        serviceValue: [
          { required: true, message: "业务值不能为空", trigger: "blur" }
        ],
      }
    };
  },
  computed: {
    dictionary() {
      return dictionary
    }
  },
  methods: {
    // 获取列表
    initData() {
      let params = {
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize
      };
      this.loading = true;
      dataDictionaryList(params).then(res => {
        if (res.data.code == 200) {
          this.dictionaryList = this.handleTree(res.data.data.records, "id");
          this.loading = false;
        }else{
          this.$message.error("加载时间过长，请重新请求！");
          this.loading = false;
        }
      });
    },
    /** 查询菜单下拉树结构 */
    getParentAll() {
      dataDictionaryParentAll().then(res => {
        this.optParentDictionary = res.data.data;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        parentId: undefined,
        name: undefined,
        icon: undefined,
        type: "1",
        serialNum: undefined,
        hidden: "1",
        status: "1"
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.initData();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset();
      this.getParentAll();
      if (row != null && row.id) {
        this.form.parentId = row.id;
      }
      this.open = true;
      this.title = "添加数据字典";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      this.getParentAll();
      getDataDictionary({id : row.id}).then(res => {
        this.form = res.data.data;
        if(this.form.parentId === -1){
          this.form.parentId = null;
          this.showServiceValueInput = false;
        } else {
          this.showServiceValueInput = true;
        }
        this.open = true;
        this.title = "修改数据字典";
      });
    },
    /** 清空时触发*/
    handleClear() {
      if(this.title === "修改数据字典"){
        this.form.parentId = null;
      }
      // this.showServiceValueInput = true;
    },
    handleChange(value){
      if(value === ""){
        this.showServiceValueInput = false;
      } else {
        this.showServiceValueInput = true;
      }
    },
    /** 提交按钮 */
    submitForm: function() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id != undefined) {
            updateDataDictionary(this.form).then(res => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.initData();
            });
          } else {
            addDataDictionary(this.form).then(res => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.initData();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      this.$modal.confirm('是否确认删除名称为"' + row.name + '"的数据项？').then(function() {
        return delDataDictionary({id : row.id});
      }).then(() => {
        this.initData();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
    dateFormatServiceValue(row){
      return row.serviceValue === null ?"-":row.serviceValue;
    }
  },
  mounted() {
  },
  created(){
    this.initData();
  }
};
</script>
<style scoped lang="less">
.el-button {
  margin-left: 5px;
  border-radius: 3px;
  padding: 10px 20px;
}
</style>


